// import parseTime, formatTime and set to filter

/**
 * @param {asin} time
 * @param {string} label
 * @return {string}
 */
export function filterAsin(val) {
  return val.substring(6, val.length - 1)
}
